import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

export const EDITOR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputPasswordComponent),
  multi: true
};
@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.css'],
  providers: [EDITOR_VALUE_ACCESSOR]
})
export class InputPasswordComponent implements OnInit,OnChanges {
  @Input("formGroup")formGroup:FormGroup;
  @Input("formControlName")formControlName:string;
  @Input("label")label:string;
  @Input("placeholder")placeholder:string;
  @Input("disabled")disabled:boolean=false;
  value=null;
  formControl = null;
  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    var formGroup=null;
    if(changes.formGroup){
      formGroup=changes.formGroup.currentValue;
    }
    var formControlName=null;
    if(changes.formControlName){
      formControlName=changes.formControlName.currentValue;
    }
    if(formGroup&&formControlName){
      this.formControl=formGroup.get(formControlName);
    }
  }
  valueChange(value){
    this.value=value
    this.onModelChange(value);
  }

  writeValue(value: any): void {
    if (this.value !== value) {
        this.value = value;
    }
  }
  onModelChange: Function = () => {
  };

  onModelTouched: Function = () => {
  };

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
  this.disabled = isDisabled; 
  }
}
